/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Info_PickInputs */

const en_us2_exercise_personal_info_pick = /** @type {(inputs: Exercise_Personal_Info_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not sure? Pick Heaviest weight: it is the number you read on the dumbbell or the plate.`)
};

const pt_br2_exercise_personal_info_pick = /** @type {(inputs: Exercise_Personal_Info_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na dúvida, escolha Maior peso: é o número que você lê no halter ou na anilha.`)
};

const es_419_exercise_personal_info_pick = /** @type {(inputs: Exercise_Personal_Info_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tienes dudas? Elige Mayor peso: es el número que lees en la mancuerna o en el disco.`)
};

const pt_pt2_exercise_personal_info_pick = /** @type {(inputs: Exercise_Personal_Info_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na dúvida, escolhe Maior peso: é o número que lês no haltere ou no disco.`)
};

const fr_fr2_exercise_personal_info_pick = /** @type {(inputs: Exercise_Personal_Info_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas sûr ? Choisis Charge max : c'est le chiffre que tu lis sur l'haltère ou le disque.`)
};

const de_de2_exercise_personal_info_pick = /** @type {(inputs: Exercise_Personal_Info_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsicher? Nimm Höchstes Gewicht: Das ist die Zahl, die auf der Hantel oder Scheibe steht.`)
};

const it_it2_exercise_personal_info_pick = /** @type {(inputs: Exercise_Personal_Info_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non sei sicuro? Scegli Peso più alto: è il numero che leggi sul manubrio o sul disco.`)
};

/**
* | output |
* | --- |
* | "Not sure? Pick Heaviest weight: it is the number you read on the dumbbell or the plate." |
*
* @param {Exercise_Personal_Info_PickInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_info_pick = /** @type {((inputs?: Exercise_Personal_Info_PickInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Info_PickInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_info_pick(inputs)
	if (locale === "es-419") return es_419_exercise_personal_info_pick(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_info_pick(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_info_pick(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_info_pick(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_info_pick(inputs)
	return en_us2_exercise_personal_info_pick(inputs)
});
export { exercise_personal_info_pick as "exercise-personal.info_pick" }